/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-17 17:00:33
 */

import {type AnySchema, object, string} from 'yup';

// helpers
import {genericFieldsSchema, HandleProps} from '~/helpers/form-fields';

// types
import type {SelfMailerField, SelfMailerFields} from './fields-info';

export type SelfMailerProps = HandleProps<SelfMailerFields>

export const schema = object<SelfMailerFields, Record<SelfMailerField, AnySchema>>()
  .shape({
    postage_type: string().required('Postage Type is required'),
    ...genericFieldsSchema,
  });
